module.exports = __webpack_public_path__ + "img/member_id.b356664e.png";